import { GetModule } from '@/graphql/queries/pagebuilder';
import { useQuery } from '@tanstack/react-query';
import { executeGraphql, executeModule } from '../graphql/execute';
import { GetModuleBySlugQuery } from '../graphql/generated/graphql';

export const useModule = (uri: string, isPreview: boolean = false) => {
  return useQuery({
    queryKey: ['module', uri, isPreview ? 'graphql' : 'json'],

    queryFn: async () => {
      if (isPreview) {
        return executeGraphql(GetModule, { uri });
      } else {
        return executeModule<GetModuleBySlugQuery>(uri);
      }
    },
    enabled: !!uri,
    retry: 0,
    staleTime: isPreview ? 0 : 1000 * 60 * 5,
    refetchOnWindowFocus: isPreview,
  });
};
